import React from 'react';
import { useTranslation } from 'react-i18next'; // For language handling


function KSAVRF14_FAQ() {
  const { t } = useTranslation(); // Hook for translation

  return (
    <div >
    {/* Hero Section */}
    <div className="hero-banner">
      <div className="hero-content" >
        <h1 style={{ color: 'black' }}>{t('FAQ_VRF14_Title')}</h1>
        
      </div>
      
    </div>
    
    

    {/* Content Section */}
    <div className="hero-banner" style={{ backgroundColor: 'white' }}>
        <div className="hero-content">
          
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q1')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q1R1')}

          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q1R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q1R12')}</li>
          </ul></p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q2')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q2R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q3')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q3R1')}</p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q4')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q4R1')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q4R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q4R12')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q4R13')}</li>
          </ul>
          </p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q5')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q5_R1')}</p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q5_R2')}</p>

          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q6')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q6_R1')}<ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q6_R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q6_R12')}</li>
          </ul>
          </p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q6_R2')}</p>





          <table className='table-container'>
        
        <tbody>
          
          <tr>
            <td >{t('FAQ_VRF14_Q6_R1_tab1')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab2')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab3')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab2')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab4')}</td>
          </tr>
          <tr>
          <td >{t('FAQ_VRF14_Q6_R1_tab1')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab2')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab3')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab2')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab4')}</td>
          </tr>
          <tr>
          <td >......</td>
          <td >......</td>
          <td >......</td>
          <td >......</td>
          <td >......</td>
          </tr>
          <tr>
          <td >{t('FAQ_VRF14_Q6_R1_tab1')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab2')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab3')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab2')}</td>
            <td >{t('FAQ_VRF14_Q6_R1_tab4')}</td>
          </tr>
          
          
        </tbody>
      </table>
      <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q7')}</b></p>
      <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q7_R1')}</p>
      <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q8')}</b></p>
      <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q8_R1')}</p>
      <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q9')}</b></p>
      <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q9_R1')}<ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q9_R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q9_R12')}</li>
          
          </ul></p>
          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q10')}</b></p>

          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q10_R1')}
          <ul>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q10_R11')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q10_R12')}</li>
          <li style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q10_R13')} <a
              href={`mailto:${t('email_address')}`}
              target="_blank"
              rel="noopener noreferrer"
             
            > info@geosa.gov.sa</a>{t('FAQ_VRF14_Q10_R15')}</li>
          </ul></p>

          <p style={{ textAlign: 'justify' }}><b>{t('FAQ_VRF14_Q11')}</b></p>
          <p style={{ textAlign: 'justify' }}>{t('FAQ_VRF14_Q11_R1')} <a
              href={`mailto:${t('email_address')}`}
              target="_blank"
              rel="noopener noreferrer"
             
            > info@geosa.gov.sa</a>{t('FAQ_VRF14_Q11_R2')}</p>

         
          <br />          
        </div>
      </div>
      <div className="cards-space" style={{height:"40px"}}></div>
      
      
 
    
    </div>
);
}

export default KSAVRF14_FAQ;
